import React, { useEffect, useState } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Spinner,
  Table,
  UncontrolledTooltip,
} from "reactstrap"
import Modal from "react-bootstrap/Modal"
import {
  addItemSchemas,
  itemVideoValidation,
} from "components/Common/validation"
import Switch from "components/Shared/Switch"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import {
  addGalleryImages,
  addItem,
  addVideo,
  getItemsDetails,
  removeVideoUrlFromItem,
  updateItem,
} from "store/actions/itemsAction"
import Select from "react-select"
import Spinners from "components/Shared/Spinners"
import placeholderImage from "assets/images/placeholderImage.png"
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
} from "reactstrap"
import AdvanceSetting from "./AdvanceSetting"
import { getCategories } from "store/actions/categoriesAction"
import { getAllBranchs } from "store/actions/usersAction"
import { getAllModifierGroupsList } from "store/actions/modifierGroupAction"
import DeleteModal from "components/Common/DeleteModal"
import { showAlert } from "store/reducers/alertReducer"
import { getAllergensList } from "store/actions/allergensAction"
import { getIngredientsList } from "store/actions/ingredientAction"
import isPermissionEnabled, {
  getSubPermissions,
} from "common/isPermissionEnabled"
import { removeVideoUrlItem } from "store/reducers/itemsReducer"
import BackButton from "components/Shared/BackButton"
import { getCountryList } from "store/actions/countriesAction"
import { useTranslation } from "react-i18next"
import { handleFileChange } from "components/Shared/fileHandlers"
import { itemHeight, itemMaxSize, itemWidth } from "components/Common/ImageSize"
import TextError from "components/Shared/TextError"

const initialValues = {
  nameAr: "",
  nameEn: "",
  descriptionAr: "",
  descriptionEn: "",
  displayOrder: 0,
  posId: "",
  imageType: "URL",
  imageUrl: "",
  imageFile: "",
  itemPrice: null,
  originalPrice: null,
  caloriesForDisplay: "",
  personCountPerServing: "",
  caloriesForCalculations: "",
  enabled: true,
  disablePickup: true,
  disableDelivery: true,
  // ADVANCE SETTING
  category: "",
  isDiscountAllowed: false,
  isCombo: false,
  isFeatured: false,
  specialPrice: false,
  disabledBranches: [],
  outOfStockForBranches: [],
  SKU: "",
  countryCode: "",
}

const initialVideosValues = {
  video: "",
  videoUrlType: "UPLOAD",
  videoUrl: "",
}

const EditItem = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Edit Item | Namq")

  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const { categoryId, itemId } = useParams()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")
  const itemMode = searchParams.get("mode")

  const [formValues, setFormValues] = useState(initialValues)
  const [advanceSettingValues, setAdvanceSettingValues] =
    useState(initialValues)
  const [fields, setFields] = useState([])
  const [allergenModal, setAllergenModal] = useState(false)

  const { loading, error, isLoading, isUpdating, message, itemDetails } =
    useSelector(state => state.Items)

  const { allCategories } = useSelector(state => state.Categories)
  const { branchsList } = useSelector(state => state.Users)
  const { modifierGroupsList } = useSelector(state => state.ModifierGroups)
  const { allergensList } = useSelector(state => state.Allergens)
  const { ingredientsList } = useSelector(state => state.Ingredients)
  const { countryList } = useSelector(state => state.Countries)
  const { isImageCompressing } = useSelector(state => state.Common)

  const [selectedModifierGroups, setSelectedModifierGroups] = useState([])
  const [modifierGroups, setModifierGroups] = useState([])

  const [selectedAllergens, setSelectedAllergens] = useState(null)
  const [allergens, setAllergens] = useState([])

  const [selectedIngredients, setSelectedIngredients] = useState([])
  const [selectedIngredient, setSelectedIngredient] = useState(null)
  const [ingredients, setIngredients] = useState([])

  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [modifierGroupIdToDelete, setModifierGroupIdToDelete] = useState(null)

  const [showAllergenDeleteModal, setShowAllergenDeleteModal] = useState(false)
  const [allergenIdToDelete, setAllergenIdToDelete] = useState(null)

  const [ingredientModal, setIngredientModal] = useState(false)
  const [ingredientCount, setIngredientCount] = useState(1)
  const [ingredientIdToDelete, setIngredientIdToDelete] = useState(null)
  const [showIngredientDeleteModal, setShowIngredientDeleteModal] =
    useState(false)

  const [selectedGalleryImages, setSelectedGalleryImages] = useState([])
  const [galleryImages, setGalleryImages] = useState([])
  const [galleryModal, setGalleryModal] = useState(false)
  const [galleryImageIdToDelete, setGalleryImageIdToDelete] = useState(null)
  const [galleryImageDeleteModal, setGalleryImageDeleteModal] = useState(false)

  const [videoFormValues, VideoFormValues] = useState(initialVideosValues)
  const [videoUrl, setVideoUrl] = useState(null)
  const [deleteVideoModal, setDeleteVideoModal] = useState(false)

  useEffect(() => {
    if (itemMode === "edit") {
      setActiveTab("2")
    }
  }, [])

  // useEffect(() => {
  //   console.log(ingredientsList)
  // }, [ingredientsList])

  // console.log(itemDetails)
  useEffect(() => {
    getOldValues()
    getAllAllergens()
    getAllIngredients()
    fetchCountryList()
  }, [])

  const fetchModifierGroupList = countryCode => {
    dispatch(getAllModifierGroupsList({ countryCode }))
  }

  const getAllAllergens = () => {
    dispatch(getAllergensList())
  }

  const getAllIngredients = () => {
    dispatch(getIngredientsList())
  }

  const fetchCountryList = () => {
    dispatch(getCountryList())
  }

  useEffect(() => {
    // getCategoriesList()
    getBranchList()
  }, [])

  const getCategoriesList = countryCode => {
    dispatch(getCategories({ countryCode }))
  }
  const getBranchList = () => {
    dispatch(getAllBranchs())
  }

  const getOldValues = () => {
    const payload = {
      id: itemId,
    }
    dispatch(getItemsDetails(payload))
  }

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    create: null,
    edit: null,
    delete: null,
  })

  const { userRole, accountType } = useSelector(state => state.Login)

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      4,
      "menus_1",
      accountType
    )
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      4,
      "menus_2",
      accountType
    )
    const isPermissionEdit = getSubPermissions(
      userRole,
      4,
      "menus_3",
      accountType
    )
    const isPermissionDelete = isPermissionEnabled(
      userRole,
      4,
      "menus_4",
      accountType
    )
    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      create: isPermissionCreate,
      edit: isPermissionEdit,
      delete: isPermissionDelete,
    })
  }, [userRole])

  // GET OLD VALUES WHEN HAVE
  useEffect(() => {
    if (itemDetails && !loading) {
      const {
        _id,
        name,
        nameAr,
        description,
        descriptionAr,
        imageUrlType,
        imageUrl,
        displayOrder,
        price,
        originalPrice,
        calories,
        calorieCount,
        personCountPerServing,
        disableForPickup,
        disableForDelivery,
        isDiscountAllowed,
        isCombo,
        isFeatured,
        isCustomizable,
        disabledBranches,
        outOfStockForBranches,
        categoryIds,
        modifierGroups,
        status,
        prices,
        categoryId,
        SKU,
        galleryImages,
        videoUrl,
        videoUrlType,
        countryCode,
      } = itemDetails

      const matchedCountry = countryList.find(
        item => item.countryCode === countryCode
      )
      var updatedCountryCode = null
      if (matchedCountry) {
        const { name, countryCode } = matchedCountry
        updatedCountryCode = {
          label: language === "sa" ? nameAr : name,
          value: countryCode,
        }
      }
      const outOfStockBranchsIds = outOfStockForBranches?.map(item => ({
        label: language === "sa" ? item.nameAr : item.name,
        value: item._id,
      }))
      const disableBranchsIds = disabledBranches?.map(item => ({
        label: language === "sa" ? item.nameAr : item.name,
        value: item._id,
      }))

      setVideoUrl(videoUrl)

      getCategoriesList(countryCode)

      setFormValues({
        ...formValues,
        nameAr,
        nameEn: name,
        descriptionAr,
        descriptionEn: description,
        displayOrder: displayOrder,
        imageType: imageUrlType,
        imageUrl,
        imageFile: "",
        itemPrice: price,
        originalPrice: originalPrice,
        caloriesForDisplay: calorieCount,
        personCountPerServing: personCountPerServing,
        caloriesForCalculations: calorieCount,
        enabled: status === 1 ? true : false,
        disablePickup: disableForPickup,
        disableDelivery: disableForDelivery,
        disabledBranches: disableBranchsIds,
        outOfStockForBranches: outOfStockBranchsIds,
        category: categoryId?._id,
        isDiscountAllowed: isDiscountAllowed,
        isCombo: isCombo,
        isFeatured: isFeatured,
        specialPrice: isCustomizable,
        SKU,
        countryCode: updatedCountryCode,
      })

      const oldFields = prices?.map(({ _id, ...rest }) => rest)

      setFields(oldFields)
      fetchModifierGroupList(itemDetails.countryCode)
    }
  }, [itemDetails, countryList, language])

  const handleSubmit = values => {
    // console.log(values)
    setFormValues(values)

    const {
      nameAr,
      nameEn,
      descriptionAr,
      descriptionEn,
      displayOrder,
      imageType,
      imageUrl,
      imageFile,
      itemPrice,
      originalPrice,
      caloriesForDisplay,
      personCountPerServing,
      caloriesForCalculations,
      enabled,
      disablePickup,
      disableDelivery,
      countryCode,
    } = values

    const {
      category,
      isDiscountAllowed,
      isCombo,
      isFeatured,
      specialPrice,
      disabledBranches,
      outOfStockForBranches,
    } = advanceSettingValues
    let data = new FormData()
    data.append("name", nameEn)
    data.append("nameAr", nameAr)
    data.append("description", descriptionEn)
    data.append("descriptionAr", descriptionAr)
    data.append("displayOrder", displayOrder)
    data.append("imageUrl", imageUrl)
    data.append("imageUrlType", imageType)
    // data.append("status", enabled ? 1 : 0)
    data.append("image", imageFile)
    data.append("personCountPerServing", personCountPerServing)
    data.append("disableForPickup", disablePickup)
    // data.append("disableForDelivery", disableDelivery)
    data.append("price", itemPrice)
    data.append("originalPrice", originalPrice)
    data.append("calories", caloriesForCalculations)
    data.append("calorieCount", caloriesForCalculations)
    if (category) {
      data.append("categoryId", category)
    } else {
      data.append("categoryId", categoryId)
    }
    data.append("id", itemId)
    // data.append("isFeatured", isFeatured)
    // data.append("isDiscountAllowed", isDiscountAllowed)
    // data.append("isCombo", isCombo)
    data.append("isCustomizable", specialPrice)

    if (specialPrice) {
      fields.forEach((field, index) => {
        data.append(`prices[${index}][branch]`, field.branch)
        data.append(`prices[${index}][price]`, field.price)
      })
    }
    disabledBranches?.forEach((element, index) => {
      data.append(`disabledBranches[${index}]`, element)
    })
    outOfStockForBranches?.forEach((element, index) => {
      data.append(`outOfStockForBranches[${index}]`, element)
    })
    selectedAllergens?.forEach((element, index) => {
      data.append(`allergens[${index}]`, element.value)
    })
    selectedIngredients?.forEach((element, index) => {
      data.append(`ingredients[${index}][ingredient]`, element.value)
      data.append(`ingredients[${index}][quantity]`, ingredientCount)
    })

    data.append("countryCode", countryCode?.value?.toUpperCase())

    dispatch(updateItem(data))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          navigate(-1)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const [activeTab, setActiveTab] = useState("1")

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }
  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const initialSelectedModifierGroups = itemDetails?.modifierGroups?.map(
    modifierGroup => ({
      label: modifierGroup.name,
      value: modifierGroup._id,
    })
  )

  const initialSelectedAllergens = itemDetails?.allergens?.map(item => ({
    label: item.name,
    value: item._id,
  }))

  const initialSelectedIngredients = itemDetails?.ingredients?.map(item => ({
    label: item?.ingredient?.name,
    value: item?.ingredient?._id,
    count: item?.quantity,
  }))

  useEffect(() => {
    setSelectedModifierGroups(initialSelectedModifierGroups)
    setModifierGroups(itemDetails?.modifierGroups)

    setSelectedAllergens(initialSelectedAllergens)
    setAllergens(itemDetails?.allergens)

    setSelectedIngredients(initialSelectedIngredients)
    setIngredients(itemDetails?.ingredients)

    setGalleryImages(itemDetails.galleryImages)
  }, [itemDetails])

  const handleModifierGroupSelect = selected => {
    setSelectedModifierGroups(selected)
  }

  const handleAllergensOnchange = selected => {
    setSelectedAllergens(selected)
  }

  // const handleIngredientsOnchange = selected => {
  //   const updatedIngredients = [selected, ...selectedIngredients]
  //   setSelectedIngredients(updatedIngredients)
  // }

  const handleIngredientsOnchange = selected => {
    setSelectedIngredients(prev => [
      ...prev,
      {
        label: selected.label,
        value: selected.value,
        count: 1,
      },
    ])
    setSelectedIngredient(selected)
    setIngredientCount(1)
  }

  const commonUpdateItem = actionType => {
    const {
      nameAr,
      nameEn,
      descriptionAr,
      descriptionEn,
      displayOrder,
      imageType,
      imageUrl,
      imageFile,
      itemPrice,
      originalPrice,
      caloriesForDisplay,
      personCountPerServing,
      caloriesForCalculations,
      enabled,
      disablePickup,
      disableDelivery,
    } = formValues

    const {
      category,
      isDiscountAllowed,
      isCombo,
      isFeatured,
      specialPrice,
      disabledBranches,
      outOfStockForBranches,
    } = advanceSettingValues

    let data = new FormData()
    data.append("name", nameEn)
    data.append("nameAr", nameAr)
    data.append("description", descriptionEn)
    data.append("descriptionAr", descriptionAr)
    data.append("displayOrder", displayOrder)
    data.append("imageUrl", imageUrl)
    data.append("imageUrlType", imageType)
    // data.append("status", enabled ? 1 : 0)
    data.append("image", imageFile)
    data.append("personCountPerServing", personCountPerServing)
    data.append("disableForPickup", disablePickup)
    // data.append("disableForDelivery", disableDelivery)
    data.append("price", itemPrice)
    data.append("originalPrice", originalPrice),
      data.append("calories", caloriesForCalculations)
    data.append("calorieCount", caloriesForCalculations)
    if (category) {
      data.append("categoryId", category)
    } else {
      data.append("categoryId", categoryId)
    }
    data.append("id", itemId)
    // data.append("isFeatured", isFeatured)
    // data.append("isDiscountAllowed", isDiscountAllowed)
    // data.append("isCombo", isCombo)
    data.append("isCustomizable", specialPrice)

    if (specialPrice) {
      fields.forEach((field, index) => {
        data.append(`prices[${index}][branch]`, field.branch)
        data.append(`prices[${index}][price]`, field.price)
      })
    }

    disabledBranches.forEach((element, index) => {
      data.append(`disabledBranches[${index}]`, element)
    })
    outOfStockForBranches.forEach((element, index) => {
      data.append(`outOfStockForBranches[${index}]`, element)
    })
    // selectedModifierGroups.forEach((element, index) => {
    //   data.append(`modifierGroups[${index}]`, element.value)
    // })
    selectedAllergens?.forEach((element, index) => {
      data.append(`allergens[${index}]`, element.value)
    })

    // selectedIngredients?.forEach((element, index) => {
    //   data.append(`ingredients[${index}][ingredient]`, element.value)
    //   data.append(`ingredients[${index}][quantity]`, ingredientCount)
    // })

    if (selectedIngredients.length > 0) {
      selectedIngredients.forEach((ingredient, index) => {
        data.append(`ingredients[${index}][ingredient]`, ingredient.value)
        data.append(`ingredients[${index}][quantity]`, ingredient.count)
      })
    } else {
      data.append("ingredients[]", [])
    }

    dispatch(updateItem(data))
      .then(action => {
        const { statusCode, status, msg, data } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setIngredientModal(false)
          if (actionType === "ADD_MODFIER_GROUP") {
            handleClose()
            const updatedModifierGroups = data.modifierGroups
            setModifierGroups(updatedModifierGroups)
          } else if (actionType === "ADD_ALLERGENS") {
            const updatedAllergens = data.allergens
            setAllergens(updatedAllergens)
            setAllergenModal(false)
            handleClose()
          } else if (actionType === "ADD_INGREDIENTS") {
            const updatedIngredients = data.ingredients
            setIngredients(updatedIngredients)
            setIngredientCount(1)
            setSelectedIngredient(null)
          }
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const commonDeleteItem = () => {
    const updatedSelectedModifierGroups = modifierGroups.filter(
      item => item.value !== modifierGroupIdToDelete
    )

    const updatedModifiers = modifierGroups.filter(
      item => item._id !== modifierGroupIdToDelete
    )

    const updatedSelectedAllergens = selectedAllergens.filter(
      item => item.value !== allergenIdToDelete
    )
    const updatedAllergens = allergens.filter(
      item => item._id !== allergenIdToDelete
    )

    const updatedSelectedIngredients = selectedIngredients.filter(
      item => item.value !== ingredientIdToDelete
    )
    const updatedIngredients = ingredients.filter(
      item => item.ingredient._id !== ingredientIdToDelete
    )

    // console.log(ingredients)
    // console.log(ingredientIdToDelete)

    // console.log(ingredientIdToDelete)
    // console.log(updatedSelectedIngredients)
    // console.log(updatedIngredients)

    const {
      nameAr,
      nameEn,
      descriptionAr,
      descriptionEn,
      displayOrder,
      imageType,
      imageUrl,
      imageFile,
      itemPrice,
      originalPrice,
      caloriesForDisplay,
      personCountPerServing,
      caloriesForCalculations,
      enabled,
      disablePickup,
      disableDelivery,
    } = formValues

    const {
      category,
      isDiscountAllowed,
      isCombo,
      isFeatured,
      specialPrice,
      disabledBranches,
      outOfStockForBranches,
    } = advanceSettingValues

    let data = new FormData()
    data.append("name", nameEn)
    data.append("nameAr", nameAr)
    data.append("description", descriptionEn)
    data.append("descriptionAr", descriptionAr)
    data.append("displayOrder", displayOrder)
    data.append("imageUrl", imageUrl)
    data.append("imageUrlType", imageType)
    // data.append("status", enabled ? 1 : 0)
    data.append("image", imageFile)
    data.append("personCountPerServing", personCountPerServing)
    data.append("disableForPickup", disablePickup)
    // data.append("disableForDelivery", disableDelivery)
    data.append("price", itemPrice)
    data.append("originalPrice", originalPrice)
    data.append("calories", caloriesForCalculations)
    data.append("calorieCount", caloriesForCalculations)
    if (category) {
      data.append("categoryId", category)
    } else {
      data.append("categoryId", categoryId)
    }
    data.append("id", itemId)
    // data.append("isFeatured", isFeatured)
    // data.append("isDiscountAllowed", isDiscountAllowed)
    // data.append("isCombo", isCombo)
    data.append("isCustomizable", specialPrice)

    if (specialPrice) {
      fields.forEach((field, index) => {
        data.append(`prices[${index}][branch]`, field.branch)
        data.append(`prices[${index}][price]`, field.price)
      })
    }
    if (disabledBranches.length === 0) {
      data.append(`disabledBranches[]`, [])
    } else {
      disabledBranches.forEach((element, index) => {
        data.append(`disabledBranches[${index}]`, element)
      })
    }
    if (outOfStockForBranches.length === 0) {
      data.append(`outOfStockForBranches[]`, [])
    } else {
      outOfStockForBranches.forEach((element, index) => {
        data.append(`outOfStockForBranches[${index}]`, element)
      })
    }
    if (updatedModifiers.length === 0) {
      data.append(`modifierGroups[]`, [])
    } else {
      updatedModifiers.forEach((element, index) => {
        if (element?.modifierGroupId) {
          data.append(
            `modifierGroups[${index}][modifierGroupId]`,
            element?.modifierGroupId?._id
          )
          data.append(
            `modifierGroups[${index}][minQuantity]`,
            element?.minQuantity
          )
          data.append(
            `modifierGroups[${index}][maxQuantity]`,
            element?.maxQuantity
          )
        }
      })
    }
    if (updatedSelectedAllergens.length === 0) {
      data.append(`allergens[]`, [])
    } else {
      updatedSelectedAllergens?.forEach((element, index) => {
        data.append(`allergens[${index}]`, element.value)
      })
    }
    if (updatedIngredients.length === 0) {
      data.append(`ingredients[]`, [])
    } else {
      updatedIngredients?.forEach((element, index) => {
        data.append(`ingredients[${index}][ingredient]`, element.ingredient._id)
        data.append(`ingredients[${index}][quantity]`, element.quantity)
      })
    }

    dispatch(updateItem(data))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          // setSelectedModifierGroups(updatedSelectedModifierGroups)
          setModifierGroups(updatedModifiers)
          setModifierGroupIdToDelete(null)

          // setSelectedAllergens(updatedSelectedModifierGroups)
          setAllergens(updatedAllergens)
          setAllergenIdToDelete(null)
          setShowDeleteModal(false)
          setShowAllergenDeleteModal(false)

          setSelectedIngredients(updatedSelectedIngredients)
          setIngredients(updatedIngredients)
          setIngredientIdToDelete(null)
          setShowIngredientDeleteModal(false)

          dispatch(showAlert({ text: msg, type: "success" }))
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleAddAllergens = () => {
    commonUpdateItem("ADD_ALLERGENS")
  }

  const handleAddIngredient = () => {
    commonUpdateItem("ADD_INGREDIENTS")
  }

  // const incrementCount = () => {
  //   setIngredientCount(prevCount => prevCount + 1)
  // }

  // const decrementCount = () => {
  //   if (ingredientCount > 1) {
  //     setIngredientCount(prevCount => prevCount - 1)
  //   }
  // }

  const updateCount = increment => {
    if (selectedIngredient) {
      setSelectedIngredients(prev =>
        prev.map(ingredient =>
          ingredient.value === selectedIngredient.value
            ? {
                ...ingredient,
                count: Math.max(1, ingredient.count + increment),
              }
            : ingredient
        )
      )
      setIngredientCount(prev => Math.max(1, prev + increment))
    }
  }

  const handleImageUpload = event => {
    const files = event.target.files
    const selectedImages = []

    for (let i = 0; i < files.length; i++) {
      const file = files[i]
      selectedImages.push(file)
    }

    setSelectedGalleryImages(selectedImages)
  }

  const handleAddGalleryImages = () => {
    const data = new FormData()

    data.append("id", itemId)
    selectedGalleryImages.forEach((image, index) => {
      data.append(`image${index}`, image)
    })
    const totalLength = selectedGalleryImages?.length + galleryImages?.length

    if (totalLength > 6) {
      dispatch(
        showAlert({
          text: "The maximum allowable number of images for upload is 6.",
          type: "error",
        })
      )
    } else {
      dispatch(addGalleryImages(data))
        .then(action => {
          const { statusCode, status, msg, data } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            const newImages = [...galleryImages, ...data]
            setGalleryImages(newImages)
            setGalleryModal(false)
            setSelectedGalleryImages([])
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
  }

  const handleGalleryImageDelete = () => {
    const updatedGalleryImage = galleryImages.filter(
      url => url !== galleryImageIdToDelete
    )

    const data = new FormData()
    data.append("id", itemId)
    // if(selectedGalleryImages.length === 0) {
    //   data.append(`image${index}`, [])
    // }
    updatedGalleryImage.length === 0
      ? data.append(`galleryImages[]`, [])
      : updatedGalleryImage.forEach((image, index) => {
          data.append(`galleryImages[${index}]`, image)
        })
    dispatch(updateItem(data))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setGalleryImageDeleteModal(false)
          setGalleryImages(updatedGalleryImage)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleAddVideo = (values, { resetForm }) => {
    const { video, videoUrlType, videoUrl } = values
    const data = new FormData()
    data.append("id", itemId)
    data.append("video", video)
    data.append("videoUrlType", videoUrlType)
    data.append("videoUrl", videoUrl)

    dispatch(addVideo(data))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          resetForm()
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleVideoDelete = () => {
    // console.log(itemDetails.videoUrl)
    const data = new FormData()
    data.append("id", itemId)
    data.append("videoUrl", "")
    data.append("videoUrlType", "")

    dispatch(updateItem(data))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setDeleteVideoModal(false)
          dispatch(removeVideoUrlFromItem())
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  //MODIFIER GROUP EDIT
  const [editRowId, setEditRowId] = useState(null)
  const [minValue, setMinValue] = useState(null)
  const [maxValue, setMaxValue] = useState(null)

  const handleEditClick = (id, min, max) => {
    setEditRowId(id)
    setMinValue(min)
    setMaxValue(max)
  }

  const handleMinChange = e => {
    setMinValue(Number(e.target.value))
  }

  const handleMaxChange = e => {
    setMaxValue(Number(e.target.value))
  }

  const validateMinOnBlur = () => {
    if (minValue > maxValue) {
      dispatch(
        showAlert({ text: t("Min cannot be greater than Max"), type: "error" })
      )
      setMinValue(maxValue)
    }
  }

  const validateMaxOnBlur = () => {
    if (maxValue < minValue) {
      dispatch(
        showAlert({ text: t("Max cannot be less than Min"), type: "error" })
      )
      setMaxValue(minValue)
    }
  }

  const handleAddExistingModifierGroup = () => {
    // commonUpdateItem("ADD_MODFIER_GROUP")
    if (
      minValue == null ||
      maxValue == null ||
      !selectedModifierGroups?.value
    ) {
      dispatch(
        showAlert({
          text: t("Please enter values for min, max, and Modifier Groups"),
          type: "error",
        })
      )
      return
    }

    const newModifierGroups = {
      modifierGroupId: {
        _id: selectedModifierGroups?.value,
        name: selectedModifierGroups?.label,
      },
      minQuantity: minValue,
      maxQuantity: maxValue,
    }

    const updatedModifierGroups = [...modifierGroups, newModifierGroups]

    let data = new FormData()
    data.append("id", itemId)

    updatedModifierGroups?.forEach((element, index) => {
      if (element?.modifierGroupId) {
        data.append(
          `modifierGroups[${index}][modifierGroupId]`,
          element?.modifierGroupId?._id
        )
        data.append(
          `modifierGroups[${index}][minQuantity]`,
          element?.minQuantity
        )
        data.append(
          `modifierGroups[${index}][maxQuantity]`,
          element?.maxQuantity
        )
      }
    })

    dispatch(updateItem(data))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setEditRowId(null)
          setMaxValue(null)
          setMinValue(null)
          handleClose()
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  const handleSaveClick = id => {
    const updatedModifierGroups = modifierGroups?.map(group => {
      if (group._id === id) {
        return {
          ...group,
          minQuantity: minValue, // Set the new min value
          maxQuantity: maxValue, // Set the new max value
        }
      }
      return group
    })

    let data = new FormData()
    data.append("id", itemId)

    updatedModifierGroups.forEach((element, index) => {
      // Only append data if modifierGroupId exists
      if (element?.modifierGroupId) {
        data.append(
          `modifierGroups[${index}][modifierGroupId]`,
          element?.modifierGroupId?._id
        )
        data.append(
          `modifierGroups[${index}][minQuantity]`,
          element?.minQuantity
        )
        data.append(
          `modifierGroups[${index}][maxQuantity]`,
          element?.maxQuantity
        )
      }
    })

    dispatch(updateItem(data))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          setEditRowId(null)
          setMaxValue(null)
          setMinValue(null)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  if (loading) return <Spinners />

  const url =
    "https://halfmillion-dev.s3.amazonaws.com/item/video-1714478916669.mp4"

  return (
    <div className="page-content add_item_page">
      <div className="container-fluid">
        <Breadcrumbs />
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === "1" ? "active" : ""}
              onClick={() => toggleTab("1")}
            >
              {t("Modifier Groups")}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "2" ? "active" : ""}
              onClick={() => toggleTab("2")}
            >
              {t("Edit Item")}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "3" ? "active" : ""}
              onClick={() => toggleTab("3")}
            >
              {t("Advanced Settings")}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "4" ? "active" : ""}
              onClick={() => toggleTab("4")}
            >
              {t("Ingredients")}
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === "5" ? "active" : ""}
              onClick={() => toggleTab("5")}
            >
              {t("Allergens")}
            </NavLink>
          </NavItem>
          {/* <NavItem>
            <NavLink
              className={activeTab === "6" ? "active" : ""}
              onClick={() => toggleTab("6")}
            >
              {t("Gallery Images")}
            </NavLink>
          </NavItem> */}
          {/* <NavItem>
            <NavLink
              className={activeTab === "7" ? "active" : ""}
              onClick={() => toggleTab("7")}
            >
              {t("Videos")}
            </NavLink>
          </NavItem> */}
          {/* Add more tabs as needed */}
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <Card>
              <CardBody>
                <CardTitle></CardTitle>
                <div>
                  {usersPermissions.create && (
                    <>
                      <Button
                        color="success"
                        className=""
                        onClick={() => {
                          setMinValue(0)
                          setMaxValue(0)
                          handleShow()
                        }}
                      >
                        {t("Add Existing Modifier Group")}
                      </Button>
                      <Button
                        color="success"
                        className=" mx-3"
                        onClick={() =>
                          navigate(
                            `/menus/categories/${categoryId}/items/${itemId}/modifiers/add?label=${
                              language == "sa"
                                ? itemDetails.nameAr
                                : itemDetails.name
                            }`
                          )
                        }
                      >
                        {t("Create Modifier Group")}
                      </Button>
                    </>
                  )}
                </div>
              </CardBody>
            </Card>
            {/* MODIFIER GROUPS LIST */}
            <Row className="m-auto">
              {
                modifierGroups && modifierGroups?.length === 0 ? (
                  <p className="text-center my-3">
                    {t("No modifier groups found")}
                  </p>
                ) : (
                  <Card className="p-0">
                    <CardBody className="p-0">
                      <Table className="table mb-0 " hover>
                        <thead className="table-light">
                          <tr>
                            <th>{t("S. No.")}</th>
                            <th>{t("Image")}</th>
                            <th>{t("Name")}</th>
                            <th>{t("Minimum Quantity")}</th>
                            <th>{t("Maximum Quantity")}</th>

                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {modifierGroups?.map(
                            (
                              {
                                _id,
                                name,
                                nameAr,
                                imageUrl,
                                status,
                                minQuantity,
                                maxQuantity,
                                modifierGroupId,
                              },
                              index
                            ) =>
                              modifierGroupId && (
                                <tr key={_id}>
                                  <td>{index + 1}</td>
                                  <td className="text-start">
                                    <div className="left_section">
                                      <Link
                                        to={`/menus/categories/${categoryId}/items/${itemId}/modifiers/${modifierGroupId?._id}/items`}
                                      >
                                        <div className="d-flex align-items-center">
                                          <img
                                            width={47}
                                            height={44}
                                            src={
                                              modifierGroupId?.imageUrl
                                                ? modifierGroupId?.imageUrl
                                                : placeholderImage
                                            }
                                            style={{ objectFit: "contain" }}
                                          />
                                        </div>
                                      </Link>
                                    </div>
                                  </td>
                                  <td>
                                    <Link
                                      to={`/menus/categories/${categoryId}/items/${itemId}/modifiers/${modifierGroupId?._id}/items`}
                                    >
                                      <h6
                                        className="cat_title in_line_one"
                                        style={{ margin: "0 16px" }}
                                      >
                                        {language === "sa"
                                          ? modifierGroupId?.nameAr
                                          : modifierGroupId?.name}
                                      </h6>
                                    </Link>
                                  </td>
                                  <td>
                                    {editRowId === _id ? (
                                      <input
                                        type="number"
                                        value={minValue}
                                        className="form-control"
                                        onChange={handleMinChange}
                                        onBlur={validateMinOnBlur}
                                      />
                                    ) : (
                                      minQuantity ?? "-"
                                    )}
                                  </td>
                                  <td>
                                    {" "}
                                    {editRowId === _id ? (
                                      <input
                                        type="number"
                                        value={maxValue}
                                        className="form-control"
                                        onChange={handleMaxChange}
                                        onBlur={validateMaxOnBlur}
                                      />
                                    ) : (
                                      maxQuantity ?? "-"
                                    )}
                                  </td>

                                  <td>
                                    {editRowId === _id ? (
                                      <div className="d-flex gap-2">
                                        <button
                                          onClick={() => {
                                            setEditRowId(null)
                                            setMaxValue(null)
                                            setMinValue(null)
                                          }}
                                          className="btn btn-secondary"
                                        >
                                          {t("Cancel")}
                                        </button>
                                        <button
                                          onClick={() => handleSaveClick(_id)}
                                          className="btn btn-success"
                                          disabled={isLoading}
                                        >
                                          {t("Save")}
                                        </button>
                                      </div>
                                    ) : (
                                      <div className="d-flex align-items-center pe-2">
                                        {(accountType === "superadmin" ||
                                          usersPermissions.edit
                                            ?.menu_full_access_update
                                            ?.isEnabled) && (
                                          <>
                                            <i
                                              onClick={() =>
                                                handleEditClick(
                                                  _id,
                                                  minQuantity,
                                                  maxQuantity
                                                )
                                              }
                                              className="mdi mdi-pencil font-size-18 text-success mx-2 cursor-pointer"
                                            ></i>
                                          </>
                                        )}

                                        {usersPermissions.delete && (
                                          <>
                                            <i
                                              // id={`deletetooltip_${_id}`}
                                              onClick={e => {
                                                setModifierGroupIdToDelete(_id)
                                                setShowDeleteModal(true)
                                              }}
                                              className="bx bxs-trash font-size-18 mx-2 cursor-pointer"
                                              style={{ color: "#FD5F62" }}
                                            ></i>
                                            {/* <UncontrolledTooltip
                                            placement="top"
                                            target={`deletetooltip_${_id}`}
                                          >
                                            {t("Delete")}
                                          </UncontrolledTooltip> */}
                                          </>
                                        )}
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              )
                          )}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                )

                //   modifierGroups &&
                //   modifierGroups.map(modifier => (
                //     <Col xl={2} sm={6} key={modifier._id}>
                //       <Card className="full_height_card">
                //         <CardBody>
                //           <div className="menu">
                //             <i className="bx bx-dots-vertical-rounded text-black fs-4 menu_dots"></i>
                //             <div className="menu_options">
                //               <ul>
                //                 {usersPermissions.edit && (
                //                   <li>
                //                     <Link
                //                       to={`/menus/categories/${categoryId}/items/${itemId}/modifiers/edit?id=${modifier._id}`}
                //                     >
                //                       Edit
                //                     </Link>
                //                   </li>
                //                 )}
                //                 {usersPermissions.delete && (
                //                   <li>
                //                     <Link
                //                       to={"#"}
                //                       onClick={() => {
                //                         setModifierGroupIdToDelete(modifier._id)
                //                         setShowDeleteModal(true)
                //                       }}
                //                     >
                //                       Delete
                //                     </Link>
                //                   </li>
                //                 )}
                //               </ul>
                //             </div>
                //           </div>
                //           <Link
                //             to={`/menus/categories/${categoryId}/items/${itemId}/modifiers/${modifier._id}/items`}
                //           >
                //             <img
                //               src={
                //                 modifier.imageUrl
                //                   ? modifier.imageUrl
                //                   : placeholderImage
                //               }
                //               className="w-100 item_image "
                //               height={112}
                //             />
                //           </Link>
                //           <div className="inner">
                //             <h5 className="mt-3 text-center title in_2_line">
                //               {modifier.name}
                //             </h5>
                //             <div className="actions mt-2 text-center g_center  gap-2">

                //             </div>
                //           </div>
                //         </CardBody>
                //       </Card>
                //     </Col>
                //   ))
                // )
              }
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <BackButton /> {mode === "add" ? t("Add") : t("Edit")}{" "}
                  {t("Items")}
                </CardTitle>
                <Formik
                  enableReinitialize={true}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  validationSchema={addItemSchemas}
                >
                  {({
                    errors,
                    touched,
                    values,
                    isSubmitting,
                    setFieldValue,
                  }) => (
                    <Form>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="nameEn">{t("Name(English)")}</label>
                            <Field
                              type="text"
                              id="nameEn"
                              name="nameEn"
                              placeholder={t("Name(English)")}
                              className={`form-control ${
                                touched.nameEn && errors.nameEn
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="nameEn" />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="nameAr">{t("Name(عربي)")}</label>
                            <Field
                              type="text"
                              id="nameAr"
                              name="nameAr"
                              style={{ direction: "rtl" }}
                              placeholder={t("Name(عربي)")}
                              className={`form-control ${
                                touched.nameAr && errors.nameAr
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="nameAr" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="descriptionEn">
                              {t("Description(English)")}
                            </label>
                            <Field
                              as="textarea"
                              id="descriptionEn"
                              name="descriptionEn"
                              rows={1}
                              placeholder={t("Description(English)")}
                              className={`form-control ${
                                touched.descriptionEn && errors.descriptionEn
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="descriptionAr">
                              {t("Description(عربي)")}
                            </label>
                            <Field
                              as="textarea"
                              id="descriptionAr"
                              style={{ direction: "rtl" }}
                              rows={1}
                              name="descriptionAr"
                              placeholder={t("Description(عربي)")}
                              className={`form-control ${
                                touched.descriptionAr && errors.descriptionAr
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="descriptionAr" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="displayOrder">
                              {t("Display Order")}
                            </label>
                            <Field
                              type="text"
                              id="displayOrder"
                              name="displayOrder"
                              placeholder={t("Display Order")}
                              className={`form-control ${
                                touched.displayOrder && errors.displayOrder
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="displayOrder" />
                          </div>
                        </div>

                        {/* <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor="posId">Pos ID</label>
                        <Field
                          type="text"
                          id="posId"
                          name="posId"
                          placeholder="Enter POS ID"
                          className={`form-control ${
                            touched.posId && errors.posId ? "is-invalid" : ""
                          }`}
                        />
                        <TextError
                          name="posId"
                          
                        />
                      </div>
                    </div> */}

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="itemPrice">{t("Item Price")}</label>
                            <Field
                              type="text"
                              id="itemPrice"
                              name="itemPrice"
                              placeholder="e.g. 10"
                              className={`form-control ${
                                touched.itemPrice && errors.itemPrice
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="itemPrice" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="originalPrice">
                              {t("Original Price")}
                            </label>
                            <Field
                              type="text"
                              id="originalPrice"
                              name="originalPrice"
                              placeholder="e.g. 10"
                              className={`form-control ${
                                touched.originalPrice && errors.originalPrice
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="originalPrice" />
                          </div>
                        </div>

                        {/* <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="caloriesForDisplay">
                              {t("Calories For Display")}
                            </label>
                            <Field
                              type="text"
                              id="caloriesForDisplay"
                              name="caloriesForDisplay"
                              placeholder="E.g. 150- 200"
                              className="form-control"
                            />
                          </div>
                        </div> */}

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="personCountPerServing">
                              {t("Person Count Per Serving")}
                            </label>
                            <Field
                              type="text"
                              id="personCountPerServing"
                              name="personCountPerServing"
                              placeholder="E.g. 1"
                              className="form-control"
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="caloriesForCalculations">
                              {t("Calories For Calculations")}
                            </label>
                            <Field
                              type="text"
                              id="caloriesForCalculations"
                              name="caloriesForCalculations"
                              placeholder="E.g. 200"
                              className={`form-control ${
                                touched.caloriesForCalculations &&
                                errors.caloriesForCalculations
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="caloriesForCalculations" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="imageType">{t("Image Type")}</label>
                            <Field
                              as="select"
                              id="imageType"
                              name="imageType"
                              className={`form-control ${
                                touched.imageType && errors.imageType
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={e => {
                                const selectedValue = e.target.value
                                setFieldValue("imageType", selectedValue)
                                // Reset the value of imageURL and imageFile when the image type changes
                                setFieldValue("imageUrl", "")
                                setFieldValue("imageFile", null)
                              }}
                            >
                              <option value="URL">{t("Image Url")}</option>
                              <option value="UPLOAD">
                                {t("Upload Image")}
                              </option>
                            </Field>
                            <TextError name="imageType" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            {/* IMAGE URL */}
                            {values.imageType === "URL" && (
                              <div className="form_field">
                                <label htmlFor="imageUrl">{t("URL")}</label>
                                <Field
                                  type="text"
                                  id="imageUrl"
                                  name="imageUrl"
                                  className={`form-control ${
                                    touched.imageUrl && errors.imageUrl
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <TextError
                                  name="imageUrl"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            )}
                            {/* UPLOAD IMAGE */}
                            {values.imageType === "UPLOAD" && (
                              <div className="form_field position-relative">
                                <label htmlFor="imageFile">
                                  {t("Upload Image")}
                                </label>
                                <input
                                  type="file"
                                  id="imageFile"
                                  name="imageFile"
                                  className={`form-control ${
                                    touched.imageFile && errors.imageFile
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  accept="image/jpeg, image/jpg, image/png"
                                  onChange={e => {
                                    handleFileChange(
                                      e,
                                      "imageFile",
                                      setFieldValue,
                                      itemWidth,
                                      itemHeight,
                                      itemMaxSize
                                    )
                                  }}
                                />
                                <p className="pt-2">
                                  {t(
                                    "Recommended dimensions: Square Image and Size should be less than or equal to {{size}} KB",
                                    {
                                      width: itemWidth,
                                      height: itemHeight,
                                      size: itemMaxSize,
                                    }
                                  )}
                                </p>
                                {isImageCompressing && (
                                  <Spinner
                                    color="primary"
                                    className="file_upload_btn"
                                  />
                                )}
                              </div>
                            )}
                            <TextError name="imageFile" />
                          </div>
                        </div>
                        {/* <div className="col-12">
                          <span>Recommended size: 512 x 512</span>
                        </div> */}
                        {/* <div className="col-lg-6">
                      <div className="form_field">
                        <label htmlFor=""></label>
                         allItemsAdd
                      </div>
                    </div> */}

                        <div className="col-lg-6">
                          <div
                            className="form_field"
                            style={{ cursor: "not-allowed" }}
                          >
                            <label htmlFor="SKU">{t("SKU")}</label>
                            <Field
                              type="text"
                              id="SKU"
                              name="SKU"
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="mt-2">
                            <label htmlFor="countryCode">
                              <span className="text-danger">*</span>{" "}
                              {t("Select Country")}
                            </label>
                            <Select
                              value={values.countryCode}
                              onChange={selectedValue => {
                                setFieldValue("countryCode", selectedValue)
                              }}
                              options={countryList?.map(item => ({
                                label:
                                  language === "sa" ? item.nameAr : item.name,
                                value: item.countryCode,
                              }))}
                              placeholder={t("Select Country")}
                              className={`select2-selection ${
                                touched.countryCode && errors.countryCode
                                  ? "danger_color_border"
                                  : ""
                              } `}
                            />
                            <TextError name="countryCode" />
                          </div>
                        </div>

                        {/* <div className="col-lg-6">
                          <div
                            className="form_field"
                            style={{ cursor: "not-allowed" }}
                          >
                            <label htmlFor="SKU">SKU</label>
                            <Field
                              type="text"
                              id="SKU"
                              name="SKU"
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </div> */}

                        {/* <div className="col-lg-3"> */}
                        {/* <div className="col-lg-3">
                          <div className="form_field">
                            <label htmlFor="enabled">Enabled</label>
                            <Switch
                              isChecked={values.enabled}
                              onClickHandler={() => {
                                setFieldValue("enabled", !values.enabled)
                              }}
                            />
                          </div>
                        </div> */}
                        <div className="col-lg-3">
                          <div className="form_field">
                            <label htmlFor="disablePickup">
                              {t("Disable For Pickup")}
                            </label>
                            <Switch
                              isChecked={values.disablePickup}
                              onClickHandler={() => {
                                setFieldValue(
                                  "disablePickup",
                                  !values.disablePickup
                                )
                              }}
                            />
                          </div>
                        </div>

                        {/* <div className="col-lg-2">
                          <div className="form_field">
                            <label htmlFor="isDisableDelivery">
                              Disable for Delivery
                            </label>

                            <Switch
                              isChecked={values.disableDelivery}
                              onClickHandler={() => {
                                setFieldValue(
                                  "disableDelivery",
                                  !values.disableDelivery
                                )
                              }}
                            />
                          </div>
                        </div> */}
                        <div className="mt-3"></div>
                        <div className="col-12 d-flex justify-content-end my-3">
                          <Button
                            type="button"
                            className="mx-2"
                            color="secondary"
                            onClick={() => navigate(-1)}
                          >
                            {t("Cancel")}
                          </Button>
                          <Button
                            type="submit"
                            color="success"
                            disabled={isLoading || isImageCompressing}
                            className="w_fit_content"
                          >
                            {mode === "add" ? t("Add") : t("Save")}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </TabPane>

          <TabPane tabId="3">
            <Card>
              <CardBody>
                <AdvanceSetting
                  formValues={formValues}
                  allCategories={allCategories}
                  fields={fields}
                  setFields={setFields}
                  setAdvanceSettingValues={setAdvanceSettingValues}
                  branchsList={branchsList}
                  categoryId={categoryId}
                  itemId={itemId}
                  isLoading={isLoading}
                  t={t}
                  language={language}
                />
              </CardBody>
            </Card>
          </TabPane>
          <TabPane tabId="4">
            {usersPermissions.create && (
              <Card>
                <CardBody>
                  <Button
                    color="success"
                    onClick={() => setIngredientModal(true)}
                  >
                    {t("Add Ingredient")}
                  </Button>
                </CardBody>
              </Card>
            )}
            <Row>
              {ingredients && ingredients?.length === 0 ? (
                <p className="text-center my-3">{t("No ingredients found")}</p>
              ) : (
                ingredients &&
                ingredients.map(item => (
                  <Col xl={3} sm={6} key={item._id}>
                    <Card>
                      <CardBody>
                        {/* REDIRECT TO ITEMS FOR SPECIFIC CATEGORY */}

                        <img
                          src={
                            item?.ingredient?.imageUrl
                              ? item?.ingredient?.imageUrl
                              : placeholderImage
                          }
                          className="w-100 item_image "
                          height={112}
                        />
                        <div className="inner">
                          <h5 className="mt-3 text-center in_one_line">
                            {item?.ingredient?.name}
                          </h5>
                          <div className="actions mt-2 text-center g_center  gap-2">
                            {usersPermissions.delete && (
                              <i
                                className="mdi mdi-delete font-size-18 text-danger cursor-pointer"
                                onClick={() => {
                                  setIngredientIdToDelete(item.ingredient._id)
                                  setShowIngredientDeleteModal(true)
                                }}
                              ></i>
                            )}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))
              )}
            </Row>
          </TabPane>
          <TabPane tabId="5">
            {usersPermissions.create && (
              <Card>
                <CardBody>
                  <Button
                    color="success"
                    onClick={() => setAllergenModal(true)}
                  >
                    {t("Add Allergens")}
                  </Button>
                </CardBody>
              </Card>
            )}
            <Row>
              {allergens && allergens?.length === 0 ? (
                <p className="text-center my-3">{t("No allergens found")}</p>
              ) : (
                allergens &&
                allergens.map(item => (
                  <Col xl={2} sm={6} key={item._id}>
                    <Card>
                      <CardBody>
                        {/* REDIRECT TO ITEMS FOR SPECIFIC CATEGORY */}

                        <img
                          src={item.imageUrl ? item.imageUrl : placeholderImage}
                          className="w-100 item_image "
                          height={112}
                        />
                        <div className="inner">
                          <h5 className="mt-3 text-center in_one_line">
                            {item.name}
                          </h5>
                          <div className="actions mt-2 text-center g_center  gap-2">
                            {usersPermissions.delete && (
                              <i
                                className="mdi mdi-delete font-size-18 text-danger cursor-pointer"
                                onClick={() => {
                                  setAllergenIdToDelete(item._id)
                                  setShowAllergenDeleteModal(true)
                                }}
                              ></i>
                            )}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))
              )}
            </Row>
          </TabPane>
          {/* <TabPane tabId="6">
            {usersPermissions.create && (
              <Card>
                <CardBody>
                  <Button color="success" onClick={() => setGalleryModal(true)}>
                    {t("Add Gallery Images")}
                  </Button>
                </CardBody>
              </Card>
            )}
            <Row>
              {galleryImages && galleryImages?.length === 0 ? (
                <p className="text-center my-3">
                  {t("No gallery images found")}
                </p>
              ) : (
                galleryImages &&
                galleryImages.map(item => (
                  <Col xl={2} sm={6} key={item._id}>
                    <Card>
                      <CardBody>

                        <img
                          src={item ? item : placeholderImage}
                          className="w-100 item_image "
                          height={112}
                        />
                        <div className="inner">
                          <div className="actions mt-2 text-center g_center  gap-2">
                            {usersPermissions.delete && (
                              <i
                                className="mdi mdi-delete font-size-18 text-danger cursor-pointer"
                                onClick={() => {
                                  setGalleryImageIdToDelete(item)
                                  setGalleryImageDeleteModal(true)
                                }}
                              ></i>
                            )}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                ))
              )}
            </Row>
          </TabPane> */}
          {/* <TabPane tabId="7">
            {usersPermissions.create && (
              <Card>
                <CardBody>
                  <Formik
                    enableReinitialize={true}
                    initialValues={videoFormValues}
                    onSubmit={handleAddVideo}
                    validationSchema={itemVideoValidation}
                  >
                    {({
                      errors,
                      touched,
                      values,
                      isSubmitting,
                      setFieldValue,
                    }) => (
                      <Form>
                        <div className="row">
                          <div className="col-lg-4">
                            <div className="form_field">
                              <label htmlFor="videoUrlType">
                                {t("Video Type")}
                              </label>
                              <Field
                                as="select"
                                id="videoUrlType"
                                name="videoUrlType"
                                className={`form-control ${
                                  touched.videoUrlType && errors.videoUrlType
                                    ? "is-invalid"
                                    : ""
                                }`}
                                onChange={e => {
                                  const selectedValue = e.target.value
                                  setFieldValue("videoUrlType", selectedValue)
                                  setFieldValue("video", "")
                                  setFieldValue("videoUrl", "")
                                }}
                              >
                                <option value="URL">{t("URL")}</option>
                                <option value="UPLOAD">
                                  {t("Upload Video")}
                                </option>
                              </Field>
                              <TextError
                                name="videoUrlType"
                                component="div"
                                className="text-danger"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            {values.videoUrlType === "URL" && (
                              <div className="form_field">
                                <label htmlFor="videoUrl">{t("URL")}</label>
                                <Field
                                  type="text"
                                  id="videoUrl"
                                  name="videoUrl"
                                  className={`form-control ${
                                    touched.videoUrl && errors.videoUrl
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <TextError
                                  name="videoUrl"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            )}
                            {values.videoUrlType === "UPLOAD" && (
                              <div className="form_field">
                                <label htmlFor="video">{t("URL")}</label>
                                <input
                                  type="file"
                                  id="video"
                                  name="video"
                                  accept="video/mp4" // video/webm, video/ogg
                                  className={`form-control ${
                                    touched.video && errors.video
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  onChange={e => {
                                    setFieldValue(
                                      "video",
                                      e.currentTarget.files[0]
                                    )
                                  }}
                                />
                                <TextError
                                  name="video"
                                  component="div"
                                  className="text-danger"
                                />
                              </div>
                            )}
                          </div>
                          <div className="col-lg-4">
                            <div className="form_field">
                              <Button
                                color="success"
                                className="w-100 mt-4"
                                type="submit"
                                disabled={isLoading}
                              >
                                {t("Add Video")}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </CardBody>
              </Card>
            )}
            <Row>
              {!loading && !itemDetails.videoUrl ? (
                <p className="text-center my-3">{t("No video found")}</p>
              ) : (
                <Col xl={12}>
                  <Card className="position-relative">
                    <video
                      controls
                      className="w-100"
                      style={{ maxHeight: 500 }}
                    >
                      <source src={itemDetails.videoUrl} type="video/mp4" />
                      {t("Your browser does not support the video tag.")}
                    </video>
                    <i
                      className="mdi mdi-delete font-size-18 text-white bg-danger cursor-pointer g_center"
                      style={{
                        position: "absolute",
                        top: 20,
                        right: 20,
                        fontSize: 30,
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                      }}
                      onClick={() => {
                        setDeleteVideoModal(true)
                      }}
                    />
                  </Card>
                </Col>
              )}
            </Row>
          </TabPane> */}
        </TabContent>
      </div>
      <Modal show={show} className="add_modifier_modal" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t("Add Existing Modifier Group")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12">
              <div className="">
                <label htmlFor="selectModifierGroup">
                  {t("Select Existing Modifier Group")}
                </label>
                <Select
                  defaultValue={selectedModifierGroups}
                  onChange={handleModifierGroupSelect}
                  options={modifierGroupsList?.map(option => ({
                    label: language === "sa" ? option.nameAr : option.name,
                    value: option._id,
                  }))}
                  styles={{
                    control: provided => ({
                      ...provided,
                      width: "100%",
                    }),
                  }}
                  placeholder={t("Select Existing Modifier Group")}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form_field">
                <label htmlFor="selectModifierGroup">
                  {t("Minimum Quantity")}
                </label>
                <input
                  type="number"
                  value={minValue}
                  className="form-control"
                  onChange={handleMinChange}
                  onBlur={validateMinOnBlur}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form_field">
                <label htmlFor="selectModifierGroup">
                  {t("Maximum Quantity")}
                </label>
                <input
                  type="number"
                  value={maxValue}
                  className="form-control"
                  onChange={handleMaxChange}
                  onBlur={validateMaxOnBlur}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            color="success"
            disabled={
              isLoading ||
              (selectedModifierGroups && selectedModifierGroups?.length === 0)
            }
            onClick={handleAddExistingModifierGroup}
          >
            {t("Add")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ALLERGENS MODAL */}
      <Modal
        show={allergenModal}
        className="add_modifier_modal"
        onHide={() => setAllergenModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Add Allergens")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-lg-12">
            <div className="">
              <label htmlFor="selectModifierGroup">
                {t("Select Allergens")}
              </label>
              <Select
                defaultValue={selectedAllergens}
                onChange={handleAllergensOnchange}
                options={allergensList?.map(option => ({
                  label: language === "sa" ? option.nameAr : option.name,
                  value: option._id,
                }))}
                isMulti
                styles={{
                  control: provided => ({
                    ...provided,
                    width: "100%",
                  }),
                }}
                placeholder={t("Select Allergens")}
                closeMenuOnSelect={false}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            color="success"
            disabled={isLoading || selectedAllergens?.length === 0}
            onClick={handleAddAllergens}
          >
            {t("Add Allergens")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Ingredient MODAL */}
      <Modal
        show={ingredientModal}
        className="add_modifier_modal"
        onHide={() => setIngredientModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Add Ingredient")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-lg-12">
            <div className="">
              <label htmlFor="selectModifierGroup">
                {t("Select Ingredient")}
              </label>
              <Select
                defaultValue={selectedIngredient}
                onChange={handleIngredientsOnchange}
                options={ingredientsList?.map(option => ({
                  label: language === "sa" ? option.nameAr : option.name,
                  value: option._id,
                }))}
                // isMulti
                styles={{
                  control: provided => ({
                    ...provided,
                    width: "100%",
                  }),
                }}
                placeholder={t("Select Ingredient")}
              />
            </div>
          </div>
          <div className="ingredient_count">
            <button onClick={() => updateCount(-1)}>-</button>
            <span>{ingredientCount}</span>
            <button onClick={() => updateCount(1)}>+</button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            color="success"
            disabled={isLoading || selectedIngredient?.length === 0}
            onClick={handleAddIngredient}
          >
            {t("Add Ingredient")}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Gallery MODAL */}
      <Modal
        show={galleryModal}
        className=""
        onHide={() => setGalleryModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>{t("Add Gallery Images")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-lg-12">
            <div className="form_field">
              <label htmlFor="selectModifierGroup">
                {t("Select Gallery Images")}
              </label>
              <input
                type="file"
                accept="image/*"
                multiple
                onChange={handleImageUpload}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            color="success"
            disabled={isLoading || selectedGalleryImages?.length === 0}
            onClick={handleAddGalleryImages}
          >
            {t("Add")}
          </Button>
        </Modal.Footer>
      </Modal>

      <DeleteModal
        show={showDeleteModal}
        onDeleteClick={commonDeleteItem}
        isLoading={isLoading}
        onCloseClick={() => {
          setModifierGroupIdToDelete(null)
          setShowDeleteModal(false)
        }}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: "Modifier Group",
        })}
      />
      <DeleteModal
        show={showAllergenDeleteModal}
        onDeleteClick={commonDeleteItem}
        isLoading={isLoading}
        onCloseClick={() => {
          setAllergenIdToDelete(null)
          setShowAllergenDeleteModal(false)
        }}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: "Allergen",
        })}
      />
      <DeleteModal
        show={showIngredientDeleteModal}
        onDeleteClick={commonDeleteItem}
        isLoading={isLoading}
        onCloseClick={() => {
          setIngredientIdToDelete(null)
          setShowIngredientDeleteModal(false)
        }}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: "Ingredient",
        })}
      />
      <DeleteModal
        show={galleryImageDeleteModal}
        // onDeleteClick={commonDeleteItem}
        onDeleteClick={handleGalleryImageDelete}
        isLoading={isLoading}
        onCloseClick={() => {
          setGalleryImageIdToDelete(null)
          setGalleryImageDeleteModal(false)
        }}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: "Image",
        })}
      />

      <DeleteModal
        show={deleteVideoModal}
        // onDeleteClick={commonDeleteItem}
        onDeleteClick={handleVideoDelete}
        isLoading={isLoading}
        onCloseClick={() => {
          setDeleteVideoModal(false)
        }}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this {{name}}?", {
          name: "Video",
        })}
      />
    </div>
  )
}

export default EditItem
